module.exports = __webpack_public_path__ + "13_hair_gold.deb4fd2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/13_hair_gold.png
// module id = up8A
// module chunks = 0